import React, { lazy } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AirplanemodeInactiveIcon from "@mui/icons-material/AirplanemodeInactive";
import DvrIcon from "@mui/icons-material/Dvr";
import TimelineIcon from "@mui/icons-material/Timeline";
import LogoutIcon from "@mui/icons-material/Logout";

const DashboardLayout = lazy(() => import("layout/LayoutContainers/DashboardLayout"));
const DPPDashboard = lazy(() => import("components/Dashboard/DPP Dashboard/DPPDashboard"));
const DigitalPassList = lazy(() => import("components/Dashboard/Digital Passes/DigitalPassList"));
const ViewDigitalPass = lazy(() => import("components/Dashboard/Digital Passes/ViewDigitalPass"));
const CompanyList = lazy(() => import("components/Dashboard/CompanyList"));
const CompanyDetails = lazy(() => import("components/Dashboard/CompanyDetails"));
const SikapList = lazy(() => import("components/Dashboard/Sikaps/All Sikaps/SikapsList"));
const ViewSikap = lazy(() => import("components/Dashboard/Sikaps/View Sikap"));
const AllEvents = lazy(() => import("components/Dashboard/MAGEvents/Allevents"));
const Logout = lazy(() => import("components/Auth/Logout"));

const ppcAdminRoutes = [
  {
    type: "title",
    title: "Dashboard",
    key: "dashboard-pages",
  },
  {
    type: "collapse",
    name: "DPP Dashboard",
    key: "/dashboard/penangport",
    route: "/dashboard/penangport",
    component: (
      <DashboardLayout>
        <DPPDashboard />
      </DashboardLayout>
    ),
    icon: <DashboardIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-dashboard" },
  {
    type: "title",
    title: "DigitalPortpass",
    key: "digitalpass-pages",
  },
  {
    type: "collapse",
    name: "Active Portpass",
    key: "/digitalpass/active",
    route: "/digitalpass/active",
    component: (
      <DashboardLayout>
        <DigitalPassList key="active" type="active" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeActiveIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Inactive Portpass",
    key: "/digitalpass/inactive",
    route: "/digitalpass/inactive",
    component: (
      <DashboardLayout>
        <DigitalPassList key="inactive" type="inactive" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeInactiveIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "All Portpass",
    key: "/digitalpass/all",
    route: "/digitalpass/all",
    component: (
      <DashboardLayout>
        <DigitalPassList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
  },
  {
    type: null,
    route: "/digitalpass/:_id",
    key: "/digitalpass/:_id",
    component: (
      <DashboardLayout>
        <ViewDigitalPass />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-passes" },
  {
    type: "title",
    title: "Companies",
    key: "company-pages",
  },
  {
    type: "collapse",
    route: "/companies/all",
    name: "All Companies",
    key: "/companies/all",
    icon: <DvrIcon />,
    component: (
      <DashboardLayout>
        <CompanyList key="all" type="all" />
      </DashboardLayout>
    ),
    noCollapse: true,
  },
  {
    type: null,
    route: "/company/:id",
    key: "/company/:id",
    component: (
      <DashboardLayout>
        <CompanyDetails />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-companies" },
  {
    type: "title",
    title: "Sikaps",
    key: "sikaps-pages",
  },
  {
    type: "collapse",
    name: "All Sikaps",
    key: "/sikaps/all",
    route: "/sikaps/all",
    component: (
      <DashboardLayout>
        <SikapList key="all" type="all" />
      </DashboardLayout>
    ),
    noCollapse: true,
    icon: <FormatListBulletedIcon />,
  },
  {
    type: null,
    route: "/sikaps/view/:id",
    key: "/sikaps/view/:id",
    component: (
      <DashboardLayout>
        <ViewSikap />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-sikaps" },
  {
    type: "title",
    title: "MAG Events",
    key: "events-pages",
  },
  {
    type: "collapse",
    name: "Gate Events",
    key: "/events/penangport/all",
    route: "/events/penangport/all",
    component: (
      <DashboardLayout>
        <AllEvents key="penangport" type="penangport" />
      </DashboardLayout>
    ),
    icon: <TimelineIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-events" },
  { type: "title", title: "Profile", key: "profile-pages" },
  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "logout",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-logout" },
];

export default ppcAdminRoutes;
